<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '证书新增' : '证书编辑'"
    :enableDrag="true"
    width="500px"
    @close="cancel"
  >
    <dynamic-form
      :formConfig="formConfig"
      v-model="form"
      @submit="doSubmit"
      @cancelForm="cancel"
      ref="pageForm"
    ></dynamic-form>
  </drag-dialog>
</template>

<script>
import { add, edit } from "@/api/certificate";
import DragDialog from "@/components/DragDialog";
import "@/components/dynamic-form";
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    supThis: {
      type: Object
    }
  },
  components: {
    DragDialog
  },
  created() {},
  data() {
    return {
      loading: false,
      dialog: false,
      form: {},
      // 表单配置
      formConfig: {
        formItemList: [
          {
            type: "text",
            maxlength: "50",
            showWordLimit: true,
            key: "code",
            label: "证书代码",
            value: "",
            rules: [
              { required: true, message: "证书代码生成失败", trigger: "blur" },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "证书代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "textarea",
            maxlength: "100",
            showWordLimit: true,
            key: "name",
            label: "证书名称",
            value: "",
            placeholder: "请输入证书名称",
            rules: [
              { required: true, message: "证书名称不能为空", trigger: "blur" }
            ]
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            validateEvent: true,
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      }
    };
  },
  methods: {
    cancel() {
      this.resetForm();
    },
    doSubmit(val) {
      this.form = val;
      if (this.isAdd) {
        this.doAdd();
      } else this.doEdit();
    },
    doAdd() {
      add(this.form)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    doEdit() {
      edit(this.form)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
        })
        .catch(err => {
          this.loading = false;
          console.log(err.response.data.message);
        });
    },
    resetForm() {
      this.dialog = false;
      this.$refs.pageForm.resetForm();
      this.form = {}
    }
  }
};
</script>

<style scoped>
</style>
